import app from '$$app';
import { resourceHelper } from './helpers';

async function onTaskResourceUpdated(event) {
  const { data, innerSettings } = event;
  let taskIds = [];

  if (innerSettings.projectId) {
    taskIds = resourceHelper(data.updated, +innerSettings.projectId, innerSettings.resourcesToTasks);
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    projects: [event.innerSettings.projectId],
    tasks: taskIds,
  });
}

export default onTaskResourceUpdated;
